import { isFunction, isString } from 'es-toolkit/compat';
import axios from 'axios';
import { getAccessToken as retrieveAccessToken } from '@oliasoft/pkce';
import { createAction } from '@reduxjs/toolkit';
import ClientConfig from 'client/config';
import { toast } from '@oliasoft-open-source/react-ui-library';

export const apiCallBegan = createAction<unknown>('api/CallBegan');

export const apiCallSuccess = createAction('api/CallSuccess');

export const apiCallFailed = createAction<unknown>('api/CallFailed');

const serializeError = (e: Error) => {
  return {
    message: e.message,
    stack: e.stack,
    name: e.name,
  };
};

// @ts-ignore
export const dispatchAPICallback = (dispatch, action, payload?) => {
  if (action) {
    if (isFunction(action)) {
      dispatch(action(payload));
    } else if (isString(action)) {
      dispatch({
        type: action,
        ...(payload ? { payload } : {}),
      });
    } else {
      console.error('Unhandled API callback type');
    }
  }
};

export const getAccessToken = () => {
  if (!ClientConfig.config.pkce.provider) {
    return 'NO_PKCE_ACCESS_TOKEN_YET';
  }
  const accessToken = retrieveAccessToken(
    ClientConfig.config.pkce.provider,
    ClientConfig.config.applicationId,
    ClientConfig.config.idpServerUrl,
  );
  return accessToken;
};

// @ts-ignore
const api = ({ dispatch }) => (next) => async (action) => {
  if (action.type !== apiCallBegan.type) {
    return next(action);
  }

  const {
    baseUrl = ClientConfig.config.owaApiUrl,
    url,
    method,
    headers,
    data,
    params,
    onStart,
    onSuccess,
    onError,
    responseType,
    onUploadProgress,
    onAfterSuccess,
    toastOnSuccess,
    toastOnError,
    successMessage,
    successTitle = 'Success',
  } = action.payload;

  if (onStart) {
    dispatchAPICallback(dispatch, onStart);
  }
  next(action);

  try {
    const response = await axios.request({
      url,
      method,
      baseURL: baseUrl,
      headers: {
        ...headers,
        Authorization: `Bearer ${getAccessToken()}`,
        'x-ui-request': true,
      },
      params,
      data,
      responseType,
      onUploadProgress,
    });
    dispatch(apiCallSuccess(response.data));
    if (toastOnSuccess && successMessage) {
      toast({
        message: {
          type: 'Success',
          icon: true,
          content: successTitle,
          details: successMessage,
        },
      });
    }
    if (onAfterSuccess) {
      dispatchAPICallback(dispatch, onAfterSuccess, response.data);
    }
    dispatchAPICallback(dispatch, onSuccess, response.data);
  } catch (error: any) {
    dispatch(apiCallFailed(error));
    dispatchAPICallback(dispatch, onError, serializeError(error as any));
    if (toastOnError) {
      toast({
        message: {
          type: 'Error',
          icon: true,
          content: 'Error',
          details: error?.response?.data?.message ?? error?.message,
        },
      });
    }
  }
};

export default api;
